import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@material-ui/core";

import {
  AssessmentCard,
  Button,
  DropdownSelect,
  StyledGrid
} from "components/simple";
import { breakpoints } from "style/constants";

interface HourMinuteQuestionProps {
  answer?: Record<string, string>[];
  callback: React.Dispatch<
    React.SetStateAction<Record<string, Record<string, string>[]>>
  >;
  dropdownDefault?: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  options: Record<string, number | string>[];
  optionsSecondary: Record<string, number | string>[];
  question: string;
  subtext?: string;
  skipCallback?: React.Dispatch<React.SetStateAction<string>>;
  label: string;
  secondaryLabel: string;
}

function findKeyWithValue(
  options: Record<string, number | string>[],
  optionsSecondary: Record<string, number | string>[],
  value: number
): string {
  return Object.keys(
    options.find(entry => {
      return entry[Object.keys(entry)[0]] === value;
    }) || {}
  )[0];
}

const HourMinuteQuestion: React.FC<HourMinuteQuestionProps> = ({
  answer,
  callback,
  dropdownDefault,
  options,
  optionsSecondary,
  question,
  subtext,
  skipCallback,
  label,
  secondaryLabel
}: HourMinuteQuestionProps) => {
  const [disabled, setDisabled] = useState(true);
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);

  const [dropdownAnswer, dropdownSecondaryAnswer] = answer || [null, null];
  const dropdownValue = dropdownAnswer ? Object.values(dropdownAnswer)[0] : "";
  const dropdownSecondaryValue = dropdownSecondaryAnswer
    ? dropdownSecondaryAnswer["1"]
    : "";

  const [select, setSelect] = useState<string>(dropdownValue);
  const [selectSecondary, setSelectSecondary] = useState<string>(
    dropdownSecondaryValue
  );

  useEffect(() => {
    if (select) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [select]);

  useEffect(() => {
    const dropdownValue = dropdownAnswer
      ? Object.values(dropdownAnswer)[0]
      : "";
    setSelect(dropdownValue);
  }, [prompt]); // eslint-disable-line

  useEffect(() => {
    const dropdownSecondaryValue = dropdownSecondaryAnswer
      ? Object.values(dropdownSecondaryAnswer)[1]
      : "";
    setSelectSecondary(dropdownSecondaryValue);
  }, [prompt]); // eslint-disable-line

  return (
    <AssessmentCard
      question={question}
      skipCallback={skipCallback}
      subtext={subtext}
    >
      <StyledGrid
        item
        maxWidth="560px"
        marginBottom="1.5rem"
        marginTop="1.25rem"
        width="100%"
      >
        <DropdownSelect
          callback={setSelect}
          defaultText={label}
          options={options}
          value={select}
        />
      </StyledGrid>
      <StyledGrid item maxWidth="560px" width="100%">
        {select && (
          <DropdownSelect
            callback={setSelectSecondary}
            defaultText={secondaryLabel}
            options={optionsSecondary}
            value={selectSecondary}
          />
        )}
      </StyledGrid>
      <StyledGrid item marginTop="50px">
        <Button
          data-testid="next-btn"
          wide={!mobile}
          disabled={disabled}
          stickyFooter={mobile}
          fullWidth={mobile}
          onClick={() => {
            setDisabled(true);
            setSelect("");
            setSelectSecondary("");
            callback({
              response: [
                {
                  [findKeyWithValue(
                    options,
                    optionsSecondary,
                    parseInt(select)
                  )]: select
                },
                { 1: selectSecondary }
              ]
            });
          }}
          zIndex={100}
        >
          Next
        </Button>
      </StyledGrid>
    </AssessmentCard>
  );
};

export default HourMinuteQuestion;
